module.exports = __webpack_public_path__ + "img/metric-qr-code.964504a3.png";